import type { GetImpulseFormInput, GetImpulseFormInputSetter, GetImpulseFormOutputVerbose } from "~/tools/impulse-form";
import { Template } from "~/tools/template";

import type { TimeSeriesQuery } from "../../../common/dashboard-spec";
import { WidgetQuery } from "../../widget-form/query/form-state";
import type { FormProcessor } from "../_form-processor";

type Spec = TimeSeriesQuery;
type FormState = WidgetQuery;
type Input = GetImpulseFormInput<FormState>;

const DEFAULT = WidgetQuery.default satisfies Input;

function specToInput({ query, alias, minStep }: Spec): Input {
	return {
		promql: query.source,
		alias: alias?.source ?? DEFAULT.alias,
		minStep: minStep?.source ?? DEFAULT.minStep,
	} satisfies GetImpulseFormInputSetter<FormState>;
}

function verboseOutputToSpec({ promql, alias, minStep }: GetImpulseFormOutputVerbose<FormState>): Spec {
	return {
		query: promql ?? Template(""),
		alias: alias ?? undefined,
		minStep: minStep ?? undefined,
	};
}

const FormState = {
	init: WidgetQuery.init,
	specToInput,
	outputToSpec: verboseOutputToSpec,
	verboseOutputToSpec,
} satisfies FormProcessor<Spec, FormState, Input>;

export { FormState };
